if (process.env.VUE_APP_API_URL === undefined) throw Error('配置错误：VUE_APP_API_URL');
if (process.env.VUE_APP_GZH_APPID === undefined) throw Error('配置错误：VUE_APP_GZH_APPID');
if (process.env.VUE_APP_COMPONENT_APPID === undefined) throw Error('配置错误：VUE_APP_COMPONENT_APPID');

const api_url = process.env.VUE_APP_API_URL;
const 公众号AppId = process.env.VUE_APP_GZH_APPID as string;
const 第三方AppId = process.env.VUE_APP_COMPONENT_APPID as string;
const 微信OAuth网关地址 = process.env.VUE_APP_WX_OAUTH_GATEWAY || undefined;

const config = {
    微信公众号AppId: 公众号AppId,
    微信第三方AppId: 第三方AppId,
    Authority: api_url,
    Main: {
        Host: api_url,
    },
    微信OAuth网关地址,
};

export default config;
